package top.wcpe.allincore.ui.runtime.render.model

/**
 * GUI 混合模式（CSS mix-blend-mode 子集）。
 *
 * 描述一个 UI 元素颜色与其背后「已绘制内容」的合成方式，由平台层翻译为固定函数 GL
 * 混合函数。不复用 3D 网格材质的 BlendMode（OPAQUE/CUTOUT/TRANSLUCENT 语义是渲染管线的
 * 深度/Alpha 处理，与 GUI 颜色合成无关）。
 *
 * **枚举的序数（ordinal）即平台接缝 `UiRenderBridge.pushBlendMode(int)` 的 `mode` 形参约定**，
 * 新增枚举值必须追加到末尾以保持序数稳定。
 *
 * ADR-0072 决策 1 镜像：真源为 `platform-client-api` 的
 * `top.wcpe.allincore.platform.client.api.render.GuiBlendMode`
 * （纯 Java 8 对外 API，按 ADR-0002 不得 KMP 化）。值名与声明序逐一照抄真源
 * （ordinal 为跨层接缝约定，冻结保序），一致性由 jvmTest 的 RenderModelConsistencyTest
 * 逐值断言 name + ordinal 守护。
 */
enum class GuiBlendMode {
    /** 正常混合：等价于 vanilla 默认混合函数（SRC_ALPHA, ONE_MINUS_SRC_ALPHA），即不改变合成行为（零回归默认）。 */
    NORMAL,

    /** 正片叠底：结果 = src × dst，整体变暗（GL 固定函数 blendFunc(DST_COLOR, ZERO)）。 */
    MULTIPLY,

    /** 滤色：结果 = src + dst − src × dst，整体变亮（GL 固定函数 blendFunc(ONE, ONE_MINUS_SRC_COLOR)）。 */
    SCREEN,

    /** 线性减淡（叠加）：结果 = src × srcAlpha + dst，发光式提亮（GL 固定函数 blendFunc(SRC_ALPHA, ONE)）。 */
    ADDITIVE,
}
